import { ApiService } from 'js/src/client/services.gen';

export type ChartGenerationOptions = {
    chartType?: string;
    data?: string;
    customPrompt?: string;
    /**
     * Currently-rendered ECharts config. When provided, the LLM is instructed to keep all
     * styling/animation/graphic structure from this config and only update data-bearing
     * fields (and the text strings inside title/graphic if the words become stale).
     */
    baseConfig?: unknown;
};

export type GeneratedChartConfig = { echarts?: unknown };

export async function generateChartConfig(
    sceneText: string,
    options?: ChartGenerationOptions,
): Promise<GeneratedChartConfig | undefined> {
    const { data: responseData } = await ApiService.generateChartConfigCreate({
        body: {
            scene_text: sceneText,
            chart_type: options?.chartType,
            chart_data: options?.data,
            custom_prompt: options?.customPrompt,
            base_config: options?.baseConfig,
        },
    });

    return responseData.config as GeneratedChartConfig | undefined;
}
